import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Panel } from 'foundations-components/transitional/components/Panel';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Box } from 'foundations-components/transitional/components/Box';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getIsRememberThisDeviceModalOpen } from 'LoginUI/selectors/TwoFactorAuth';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RememberThisDevice = ({
  onRemember,
  onRememberNot
}) => {
  const isOpen = useSelector(getIsRememberThisDeviceModalOpen);
  if (!isOpen) return null;
  const renderIllustration = () => {
    return /*#__PURE__*/_jsx(Illustration, {
      name: "mobile-onboarding-account-ready",
      width: "100%"
    });
  };
  return /*#__PURE__*/_jsx(Panel, {
    width: "100%",
    animate: false,
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      flexWrap: "wrap",
      marginBlockStart: "1400",
      padding: "1400",
      "aria-label": `${I18n.text('login.twoFactor.rememberMe.title')} ${I18n.text('login.twoFactor.rememberMe.body')}`,
      children: [/*#__PURE__*/_jsxs(Box, {
        basis: 475,
        shrink: 1,
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("h1", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "login.twoFactor.rememberMe.title"
            })
          }), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "login.twoFactor.rememberMe.body"
            })
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "row",
          marginBlockStart: "1200",
          children: [/*#__PURE__*/_jsx(Button, {
            onClick: onRemember,
            use: "primary",
            "data-2fa-rememberme": "true",
            autoFocus: true,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "login.twoFactor.rememberMe.rememberMeButton"
            })
          }), /*#__PURE__*/_jsx(Button, {
            onClick: onRememberNot,
            "data-2fa-rememberme": "false",
            marginBlockStart: "0",
            marginInlineStart: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "login.twoFactor.rememberMe.rememberMeNotButton"
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(Box, {
        basis: 150
      }), /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(Text, {
          textAlign: "center",
          children: renderIllustration()
        })
      })]
    })
  });
};
RememberThisDevice.propTypes = {
  onRemember: PropTypes.func.isRequired,
  onRememberNot: PropTypes.func.isRequired
};
export default RememberThisDevice;